module.exports = __webpack_public_path__ + "img/pro_ar_04.2b9c721a.jpg";